import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

/**
 * Smart landing page component that redirects users based on their role:
 * - Admins → Dashboard (system-wide stats)
 * - Regular Users → Gateways (their main page)
 */
const SmartLanding = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Check if user is admin
  const isAdmin = user?.isGatewayOwner === true;

  // Redirect based on role
  if (isAdmin) {
    return <Navigate to="/dashboard" replace />;
  } else {
    return <Navigate to="/gateways" replace />;
  }
};

export default SmartLanding;


